var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.data.backgroundColor === 'accent' ||
    _vm.data.backgroundColor === 'accent-muted'
      ? 'theme-provider'
      : 'div',{tag:"component",attrs:{"theme":_vm.data.backgroundColor === 'accent'
      ? _vm.themes.DARK
      : _vm.data.backgroundColor === 'accent-muted'
      ? _vm.themes.LIGHT
      : undefined,"fill-background":false}},[_c('div',{class:`g-background-${_vm.data.backgroundColor || 'primary'}`},[_c('div',{class:{
        'content-container':
          _vm.data.displayOptions && _vm.data.displayOptions.hasContentContainer,
        'pt-16': _vm.data.displayOptions && _vm.data.displayOptions.hasPaddingTop,
        'pb-16': _vm.data.displayOptions && _vm.data.displayOptions.hasPaddingBottom,
      }},[(_vm.data.body && _vm.data.body.length)?[(_vm.data.title)?_c('h2',{class:_vm.sectionTitleClass},[_c('SanityBlockContent',{attrs:{"inline-only":true,"blocks":_vm.data.title}})],1):_vm._e(),_vm._v(" "),_c('v-row',_vm._b({class:{
            'my-0':
              _vm.data.displayOptions && _vm.data.displayOptions.hasContentContainer,
            'ma-0': !(
              _vm.data.displayOptions && _vm.data.displayOptions.hasContentContainer
            ),
          }},'v-row',_vm.rowProps,false),[_vm._l((_vm.data.body),function(body,j){return [_c('v-col',_vm._b({key:body._key || j,class:body.backgroundColor && !!body.backgroundColorIncludesGutters
                  ? `g-background-${body.backgroundColor}`
                  : ''},'v-col',_vm.getColProps(body.vColOptions),false),[_c('div',{class:{
                  [`pa-3 fill-height g-background-${body.backgroundColor}`]:
                    body.backgroundColor &&
                    !body.backgroundColorIncludesGutters,
                }},[_c(body.backgroundColor === 'accent' ||
                    body.backgroundColor === 'accent-muted'
                      ? 'theme-provider'
                      : 'div',{tag:"component",attrs:{"theme":body.backgroundColor === 'accent'
                      ? _vm.themes.DARK
                      : body.backgroundColor === 'accent-muted'
                      ? _vm.themes.LIGHT
                      : undefined,"fill-background":false}},[(body.body)?_c('SanityBlockContent',{class:{
                      'main-block-content': true,
                      [_vm.getColTextStyle(body.textStyles)]: true,
                    },attrs:{"blocks":body.body}}):_vm._e()],1)],1)])]})],2)]:_vm._e()],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }